var _g, _line, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.9871,
    x1: 25.9,
    y1: 37.9,
    x2: 25.9,
    y2: 195.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "22.9,38.8 25.9,33.7 28.8,38.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "22.9,194.6 25.9,199.7 28.8,194.6  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.1356,
    x1: 2.7,
    y1: 230.2,
    x2: 178.7,
    y2: 230.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M186.8,230.6v-4.8h3.2v0.5h-2.6v1.6h2.5v0.5h-2.5v2.2H186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M190.7,230.6v-4.8h0.6v4.3h2.3v0.5H190.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M194.4,229.4c-0.2-0.4-0.3-0.8-0.3-1.3s0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9s0.8-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.3s-0.1,0.9-0.3,1.3s-0.5,0.7-0.9,0.9 c-0.4,0.2-0.8,0.3-1.3,0.3c-0.5,0-0.9-0.1-1.3-0.3S194.6,229.8,194.4,229.4z M194.8,228.1c0,0.4,0.1,0.7,0.2,1 c0.1,0.3,0.4,0.5,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3s0.7-0.1,0.9-0.3s0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1c0-0.6-0.2-1-0.5-1.4 c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-1,0.2-1.3,0.6C194.9,227.1,194.8,227.6,194.8,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M200,229.4c-0.2-0.4-0.3-0.8-0.3-1.3s0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9s0.8-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.3s-0.1,0.9-0.3,1.3s-0.5,0.7-0.9,0.9 c-0.4,0.2-0.8,0.3-1.3,0.3c-0.5,0-0.9-0.1-1.3-0.3S200.2,229.8,200,229.4z M200.3,228.1c0,0.4,0.1,0.7,0.2,1 c0.1,0.3,0.4,0.5,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3s0.7-0.1,0.9-0.3s0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1c0-0.6-0.2-1-0.5-1.4 c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-1,0.2-1.3,0.6C200.5,227.1,200.3,227.6,200.3,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M205.5,230.6v-4.8h1.9c0.5,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.3-0.3,0.4s-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1l1.3,2h-0.7l-1.2-1.9h-1v1.9H205.5z M206.1,228.1h1.3 c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3h-1.3V228.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 50.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1479,
    strokeMiterlimit: 10,
    width: 107.2,
    height: 148.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9,
    y: 59.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1479,
    strokeMiterlimit: 10,
    width: 89.5,
    height: 131.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 29.3,
    fill: "#FFFFFF",
    width: 137,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 29.3,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.5958,
    width: 137,
    height: 4.3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5C);
export default __webpack_public_path__ + "static/media/5c.51355a1e9e481f8b3057d4d39d26f2ac.svg";
export { ForwardRef as ReactComponent };